<template>
  <div id="app">
    <div id='main'>
      <div id='search'>
        <div id='all'>
          <button v-on:click="all">All Heroes</button>
        </div>

        <p>コスト</p>
        <div id='cost'>
          <button v-on:click="cost1">1</button>
          <button v-on:click="cost2">2</button>
          <button v-on:click="cost3">3</button>
          <button v-on:click="cost4">4</button>
          <button v-on:click="cost5">5</button>
        </div>

        <p>種族</p>
        <div id='species'>
          <button v-on:click="demon">Demon</button>
          <button v-on:click="dragon">Dragon</button>
          <button v-on:click="dwarf">Dwarf</button>
          <button v-on:click="elemental">Elemental</button>
          <button v-on:click="elf">Elf</button>
          <button v-on:click="goblin">Goblin</button>
          <button v-on:click="human">Human</button>
          <button v-on:click="ogre">Ogre</button>
          <button v-on:click="orc">Orc</button>
          <button v-on:click="naga">Naga</button>
          <button v-on:click="troll">Troll</button>
          <button v-on:click="undead">Undead</button>
          <button v-on:click="god">God</button>
        </div>

        <p>クラス</p>
        <div id='class'>
          <button v-on:click="assassin">Assassin</button>
          <button v-on:click="demonHunter">DemonHunter</button>
          <button v-on:click="druid">Druid</button>
          <button v-on:click="knight">Knight</button>
          <button v-on:click="hunter">Hunter</button>
          <button v-on:click="priest">Priest</button>
          <button v-on:click="mage">Mage</button>
          <button v-on:click="mech">Mech</button>
          <button v-on:click="shaman">Shaman</button>
          <button v-on:click="warlock">Warlock</button>
          <button v-on:click="warrior">Warrior</button>
        </div>

        <p>スキルタイプ</p>
        <div id='ability'>
          <button v-on:click="autoCast">AutoCast</button>
          <button v-on:click="channeled">Channeled</button>
          <button v-on:click="noTarget">NoTarget</button>
          <button v-on:click="passive">Passive</button>
          <button v-on:click="pointTarget">PointTarget</button>
          <button v-on:click="unitTarget">UnitTarget</button>
        </div>

        <div id='icons'>
          <transition-group name="list" tag="p">
            <span v-for="item in items" v-bind:key="item.name" class="list-item">
              <img :src=getImgPath(item.name) v-on:mouseover="mouseover" :charname=item.name>
            </span>
          </transition-group>
        </div>
      </div>

      <div id='info'>
          <span>{{selected.jname}}({{selected.name}})</span>
          <div id='status'>
            <div id='status-1'>
              <img :src=getStatus1()>
            </div>
            <div id='status-2'>
              <img :src=getStatus2()>
            </div>
          </div>
          <div id='skill'>
            <img :src=getSkill()>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

const info = [
   {name:'Axe', cost:1, jname:'アックス', species:'Orc', class:'Warrior', ability:'No Target'},
   {name:'Enchantress', cost:1, jname:'エンチャントレス', species:'Beast', class:'Druid', ability:'No Target'},
   //{name:'Ogre_Magi', cost:1, jname:'オーガマギ', species:'Ogre', class:'Mage', ability:'Auto-Cast'},
   {name:'Tusk', cost:1, jname:'タスカー', species:'Beast', class:'Warrior', ability:'Auto-Cast'},
   {name:'Drow_Ranger', cost:1, jname:'不死の射手', species:'Undead', class:'Hunter', ability:'Passive'},
   {name:'Bounty_Hunter', cost:1, jname:'ゴブリンの賞金稼ぎ', species:'Goblin', class:'Assassin', ability:'Unit Target'},
   {name:'Clockwerk', cost:1, jname:'クロックワークス', species:'Goblin', class:'Mech', ability:'No Target'},
   {name:'Shadow_Shaman', cost:1, jname:'トロルの占い師', species:'Troll', class:'Shaman', ability:'Unit Target'},
   {name:'Batrider', cost:1, jname:'トロルの蝙蝠騎士', species:'Troll', class:'Knight', ability:'Point Target'},
   {name:'Tinker', cost:1, jname:'ティンカー', species:'Goblin', class:'Mech', ability:'No Target'},
   {name:'Anti-Mage', cost:1, jname:'アンチメイジ', species:'Elf', class:'Demon Hunter', ability:'Passive'},
   {name:'Tiny', cost:1, jname:'岩のエレメント', species:'Elemental', class:'Warrior', ability:'Point Target'},
   {name:'Mars', cost:1, jname:'盾の神マルス', species:'God', class:'Warrior', ability:'Passive'},
   {name:'Winter_Wyvern', cost:1, jname:'冬のドラゴン', species:'Dragon', class:'Mage', ability:'Unit Target'},
   {name:'Crystal_Maiden', cost:2, jname:'魔女リーライ', species:'Human', class:'Mage', ability:'Passive'},
   {name:'Beastmaster', cost:2, jname:'ビーストマスター', species:'Orc', class:'Hunter', ability:'Point Target'},
   {name:'Juggernaut', cost:2, jname:'剣聖ジャガノ', species:'Orc', class:'Warrior', ability:'No Target'},
   {name:'Timbersaw', cost:2, jname:'ティンバーソー', species:'Goblin', class:'Mech', ability:'No Target'},
   {name:'Queen_of_Pain', cost:2, jname:'痛みのデーモン', species:'Demon', class:'Assassin', ability:'No Target'},
   {name:'Puck', cost:2, jname:'フェアリードラゴン', species:'Dragon/Elf', class:'Mage', ability:'Point Target'},
   {name:'Witch_Doctor', cost:2, jname:'トロルの医者', species:'Troll', class:'Warlock', ability:'Unit Target'},
   {name:'Slardar', cost:2, jname:'スラーダー', species:'Naga', class:'Warrior', ability:'Point Target'},
   {name:'Chaos_Knight', cost:2, jname:'デーモンナイト', species:'Demon', class:'Knight', ability:'Unit Target'},
   {name:'Luna', cost:2, jname:'エルフの騎士ルナ', species:'Elf', class:'Knight', ability:'Passive'},
   {name:'Nature\'s_Prophet', cost:2, jname:'フリオン', species:'Elf', class:'Druid', ability:'Point Target'},
   {name:'Morphling', cost:2, jname:'水のエレメント', species:'Elemental', class:'Assassin', ability:'Point Target'},
   {name:'Mirana', cost:2, jname:'ミラーナ', species:'Elf', class:'Hunter', ability:'Unit Target'},
   {name:'Lich', cost:2, jname:'不死の魔女リッチ', species:'Undead', class:'Mage', ability:'Unit Target'},
   {name:'Lycan', cost:3, jname:'人狼ライカン', species:'Beast/Human', class:'Warrior', ability:'Unit Target'},
   {name:'Venomancer', cost:3, jname:'ベノマンサー', species:'Beast', class:'Warlock', ability:'Point Target'},
   {name:'Omniknight', cost:3, jname:'オムニナイト', species:'Human', class:'Knight', ability:'Unit Target'},
   {name:'Razor', cost:3, jname:'雷のエレメント', species:'Elemental', class:'Mage', ability:'No Target'},
   {name:'Windranger', cost:3, jname:'エルフの射手', species:'Elf', class:'Hunter', ability:'Channeled'},
   {name:'Phantom_Assassin', cost:3, jname:'致命のアサシン', species:'Elf', class:'Assassin', ability:'Passive'},
   {name:'Abaddon', cost:3, jname:'不死の騎士王', species:'Undead', class:'Knight', ability:'Unit Target'},
   {name:'Sniper', cost:3, jname:'スナイパー', species:'Dwarf', class:'Hunter', ability:'Unit Target'},
   {name:'Viper', cost:3, jname:'毒の古竜', species:'Dragon', class:'Assassin', ability:'Unit Target'},
   {name:'Shadow_Fiend', cost:3, jname:'影のデーモン', species:'Demon', class:'Warlock', ability:'No Target'},
   {name:'Lina', cost:3, jname:'天才魔道士リアナ', species:'Human', class:'Mage', ability:'Unit Target'},
   {name:'Terroblade', cost:3, jname:'恐怖のデーモン', species:'Demon', class:'Demon Hunter', ability:'No Target'},
   {name:'Treant_Protector', cost:3, jname:'トレントの護り手', species:'Elf', class:'Druid', ability:'Unit Target'},
   {name:'Dazzle', cost:3, jname:'ダズル', species:'Troll', class:'Priest', ability:'Unit Target'},
   {name:'Doom', cost:4, jname:'ドゥームデーモン', species:'Demon', class:'Warrior', ability:'Unit Target'},
   {name:'Kunkka', cost:4, jname:'海賊王クンカ', species:'Human', class:'Warrior', ability:'Point Target'},
   {name:'Troll_Warlord', cost:4, jname:'トロルの戦将', species:'Troll', class:'Warrior', ability:'Passive'},
   {name:'Keeper_of_the_Light', cost:4, jname:'光の老魔道士', species:'Human', class:'Mage', ability:'Channeled'},
   {name:'Necrophos', cost:4, jname:'不死のネクロ', species:'Undead', class:'Warlock', ability:''},
   {name:'Templar_Assassin', cost:4, jname:'テンプラアサシン', species:'Elf', class:'Assassin', ability:'No Target'},
   {name:'Alchemist', cost:4, jname:'ゴブリン錬金術師', species:'Goblin/Ogre', class:'Warlock', ability:'No Target'},
   {name:'Disruptor', cost:4, jname:'オークの占い師', species:'Orc', class:'Shaman', ability:'Point Target'},
   {name:'Medusa', cost:4, jname:'メデューサ', species:'Naga', class:'Hunter', ability:'No Target'},
   {name:'Dragon_Knight', cost:4, jname:'ドラゴンナイト', species:'Dragon/Human', class:'Knight', ability:'No Target'},
   {name:'Lone_Druid', cost:4, jname:'ローンドルイド', species:'Beast', class:'Druid', ability:'Point Target'},
   {name:'Gyrocopter', cost:5, jname:'ジャイロコプター', species:'Dwarf', class:'Mech', ability:'Point Target'},
   {name:'Tidehunter', cost:5, jname:'タイドハンター', species:'Naga', class:'Hunter', ability:''},
   {name:'Enigma', cost:5, jname:'謎のエレメント', species:'Elemental', class:'Warlock', ability:''},
   {name:'Techies', cost:5, jname:'地雷工作員', species:'Goblin', class:'Mech', ability:'Point Target'},
   {name:'Death_Prophet', cost:5, jname:'不死の悪霊使い', species:'Undead', class:'Warlock', ability:'No Target'},
   {name:'Zeus', cost:5, jname:'雷の神ゼウス', species:'God', class:'Mage', ability:'No Target'},
   {name:'Sven', cost:5, jname:'スヴェン', species:'Demon', class:'Warrior', ability:'No Target'},
   {name:'Io', cost:5, jname:'ウィスプ', species:'Elf', class:'', ability:'Passive'},
]

export default {
  data () {
    return {
      selected: info[0],
      items: info,
    }
  },
  computed: {
  },
  methods: {
    randomIndex: function () {
      return Math.floor(Math.random() * this.items.length)
    },
    all: function () {
      this.items = info;
    },

    // コスト
    cost1: function () {
      this.items = info.filter( n => n.cost == 1)
    },
    cost2: function () {
      this.items = info.filter( n => n.cost == 2)
    },
    cost3: function () {
      this.items = info.filter( n => n.cost == 3)
    },
    cost4: function () {
      this.items = info.filter( n => n.cost == 4)
    },
    cost5: function () {
      this.items = info.filter( n => n.cost == 5)
    },

    // 種族
    beast: function () {
      this.items = info.filter( n => /Beast/.test(n.species))
    },
    demon: function () {
      this.items = info.filter( n => n.species == 'Demon')
    },
    dragon: function () {
      this.items = info.filter( n => /Dragon/.test(n.species))
    },
    dwarf: function () {
      this.items = info.filter( n => n.species == 'Dwarf')
    },
    elemental: function () {
      this.items = info.filter( n => n.species == 'Elemental')
    },
    elf: function () {
      this.items = info.filter( n => /Elf/.test(n.species))
    },
    goblin: function () {
      this.items = info.filter( n => /Goblin/.test(n.species))
    },
    human: function () {
      this.items = info.filter( n => /Human/.test(n.species))
    },
    ogre: function () {
      this.items = info.filter( n => /Ogre/.test(n.species))
    },
    orc: function () {
      this.items = info.filter( n => n.species == 'Orc')
    },
    naga: function () {
      this.items = info.filter( n => n.species == 'Naga')
    },
    troll: function () {
      this.items = info.filter( n => n.species == 'Troll')
    },
    undead: function () {
      this.items = info.filter( n => n.species == 'Undead')
    },
    god: function () {
      this.items = info.filter( n => n.species == 'God')
    },

    // クラス
    assassin: function () {
      this.items = info.filter( n => n.class == 'Assassin')
    },
    demonHunter: function () {
      this.items = info.filter( n => n.class == 'Demon Hunter')
    },
    druid: function () {
      this.items = info.filter( n => n.class == 'Druid')
    },
    knight: function () {
      this.items = info.filter( n => n.class == 'Knight')
    },
    hunter: function () {
      this.items = info.filter( n => n.class == 'Hunter')
    },
    priest: function () {
      this.items = info.filter( n => n.class == 'Priest')
    },
    mage: function () {
      this.items = info.filter( n => n.class == 'Mage')
    },
    mech: function () {
      this.items = info.filter( n => n.class == 'Mech')
    },
    shaman: function () {
      this.items = info.filter( n => n.class == 'Shaman')
    },
    warlock: function () {
      this.items = info.filter( n => n.class == 'Warlock')
    },
    warrior: function () {
      this.items = info.filter( n => n.class == 'Warrior')
    },

    // スキルタイプ
    autoCast: function () {
      this.items = info.filter( n => n.ability == 'Auto-Cast')
    },
    channeled: function () {
      this.items = info.filter( n => n.ability == 'Channeled')
    },
    noTarget: function () {
      this.items = info.filter( n => n.ability == 'No Target')
    },
    passive: function () {
      this.items = info.filter( n => n.ability == 'Passive')
    },
    pointTarget: function () {
      this.items = info.filter( n => n.ability == 'Point Target')
    },
    unitTarget: function () {
      this.items = info.filter( n => n.ability == 'Unit Target')
    },

    getImgPath (name) {
      return "./img/" + name.toLowerCase() + "/icon.png"
    },
    getStatus1 () {
      return "./img/" + this.selected.name.toLowerCase() + "/status_1.jpg"
    },
    getStatus2 () {
      return "./img/" + this.selected.name.toLowerCase() + "/status_2.jpg"
    },
    getSkill () {
      return "./img/" + this.selected.name.toLowerCase() + "/skill.jpg"
    },

    mouseover(e) {
      this.selected = info.filter(n => n.name == e.target.getAttribute('charname'))[0]
    }
  }
}
</script>

<style>
</style>
